export default __webpack_public_path__ + "static/media/CSIP_Site_Logo.e86daf54.png";